import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";


// import animated from 'animate.css'
import 'animate.css/animate.css'

import "@/assets/css/common.scss";

/* 通用组件*/
import pageHeaderBox from "@/components/pageHeaderBox";
import pageFooterBox from "@/components/pageFooterBox";
Vue.component("pageHeaderBox", pageHeaderBox);
Vue.component("pageFooterBox", pageFooterBox);

// Vue.use(animated)
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper /* { default options with global component } */);

new Vue({
  router,
  store,
  render: (h) => h(App),
  data: {
    bus: new Vue(),
  },
}).$mount("#app");
